package com.xtream.data_kmp.db.repo

import com.xtream.data_kmp.AppConfig
import com.xtream.data_kmp.WatchedSeriesStreams
import com.xtream.data_kmp.db.AppRoomDB


class WatchedSeriesRepository (
    val db: AppRoomDB,
){
    fun getWatchedStreamFlow( streamId:Int?)=db.watchedSeriesDao().getSingleFlow(streamId)
    suspend fun getWatchedStream( streamId:Int?): WatchedSeriesStreams? {
        val stream= db.watchedSeriesDao().getSingle(streamId)
    //    Log.d("VideoPlayer", "VideoPlayer: $streamId, progress: ${ stream?.progress}, ${stream?.totalProgress}")
    return stream
    }

    suspend fun deleteAll() = db.watchedSeriesDao().deleteAll()

   suspend fun insert(  watchedSeriesStreams: WatchedSeriesStreams){
        db.watchedSeriesDao().insert(watchedSeriesStreams)
        db.watchedSeriesDao().deleteByOffset(AppConfig.WATCHED_LIST_LIMIT,-1)
    }
    suspend fun deleteById(id:Int?){
        db.watchedSeriesDao().deleteById(id)
    }
}